import { connect } from 'react-redux'

import { uploadAvatarRequest } from 'store/entities/identity/actions'
import { getIdentityInitials } from 'store/entities/identity/selectors'
import ProfileFormAvatarInput from './ProfileFormAvatarInput'
import { modal } from 'store/entities/modal/actions'

const mapStateToProps = state => ({
  initials: getIdentityInitials(state),
})

const mapDispatchToProps = {
  onChange: uploadAvatarRequest,
  showModal: modal.show,
}

export default connect(mapStateToProps, mapDispatchToProps)(ProfileFormAvatarInput)
